import { useToast } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import { useLocalization } from '~/framework';

type ErrorMessages<ErrorCode extends string> = Record<ErrorCode, string> & { default: string };

export function useServiceApiErrorMessageToast<ErrorCode extends string>(
   errorMessages: ErrorMessages<ErrorCode>
) {
   const toast = useToast();

   const router = useRouter();

   const { _js } = useLocalization();

   function handleError(error: any) {
      if (error?.response?.data) {
         const { message } = error.response.data;

         if (message && errorMessages && message in errorMessages) {
            toast({
               title: _js(errorMessages[message as ErrorCode]),
               status: 'error',
               position: 'top',
            });
         }
      }
   }

   function handleErrorOrRedirectToLogin(error: any) {
      if (error?.response?.code === 401) {
         router.push('/Login');
      } else {
         handleError(error);
      }
   }

   return {
      handleError,
      handleErrorOrRedirectToLogin,
   };
}
